<div class="header">
  <h2>{{ "pages.analytics.sessions.title" | translate }}</h2>
  <div class="filters">
    <app-tutor-filter-control
      [analyticsPage]="'sessions'"
    ></app-tutor-filter-control>
    <app-date-range-control
      [analyticsPage]="'sessions'"
    ></app-date-range-control>
  </div>
</div>

<div class="grid">
  <app-kpi-sessions-summary></app-kpi-sessions-summary>

  <nb-card class="card max-height">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.sessions' | translate"
        [infoText]="'charts.descriptions.sessions' | translate"
        [isDemo]="analyticsService.isDemo('barSessions')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-bar-sessions-chart></app-bar-sessions-chart>
    </nb-card-body>
  </nb-card>

  <nb-card class="card max-height">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.sessionTotalDuration' | translate"
        [infoText]="'charts.descriptions.sessionTotalDuration' | translate"
        [isDemo]="analyticsService.isDemo('barTotalDuration')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-bar-total-duration></app-bar-total-duration>
    </nb-card-body>
  </nb-card>

  <nb-card class="card max-height">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.sessionAvgDuration' | translate"
        [infoText]="'charts.descriptions.sessionAvgDuration' | translate"
        [isDemo]="analyticsService.isDemo('barAvgDuration')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-bar-avg-duration></app-bar-avg-duration>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-2">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.sessionsHeatmap' | translate"
        [infoText]="'charts.descriptions.sessionsHeatmap' | translate"
        [isDemo]="analyticsService.isDemo('sessionsHeatmap')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-heatmap-sessions></app-heatmap-sessions>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-2">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.sessionsAndAvgDurations' | translate"
        [infoText]="'charts.descriptions.sessionsAndAvgDurations' | translate"
        [isDemo]="analyticsService.isDemo('multiLineSessionsAndAvgDurations')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-multi-line-sessions-and-avg-durations></app-multi-line-sessions-and-avg-durations>
    </nb-card-body>
  </nb-card>
</div>
